webpackJsonp([213534597649335],{

/***/ 1170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTypist = __webpack_require__(29);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	__webpack_require__(28);
	
	var _messages = __webpack_require__(27);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var someFunc = function someFunc(arg) {
	  return arg;
	};
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-content-box' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Rob\'s Structural Apps:'
	    ),
	    _react2.default.createElement(
	      _reactTypist2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Helping engineers calculating better'
	        )
	      ),
	      _react2.default.createElement(_reactTypist2.default.Delay, { ms: 400 }),
	      _messages2.default.tagline.services.map(function (service, index) {
	        return _react2.default.createElement(
	          'div',
	          { style: { display: 'inline' }, key: index },
	          _react2.default.createElement(
	            'h1',
	            { style: { display: 'inline' } },
	            _react2.default.createElement(
	              'strong',
	              null,
	              '...and faster'
	            )
	          )
	        );
	      })
	    ),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement('br', null),
	    _react2.default.createElement(
	      'h2',
	      {
	        className: '\n          js-action-button-anchor\n          c-content-box__subheadline\n          c-content-box__subheadline--with-button\n        '
	      },
	      'Find out more'
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-166bcfd951570f6f766a.js